<template>
  <div class="biz-detail-container">
    <div class="columns">
      <div class="column is-four-fifths-desktop is-four-fifths-tablet is-full-mobile is-paddingless">
        <p id="back-to-results" class="is-size-7">
          <a v-if="hasBackUrl()" href="javascript:void(0);" @click="gotoBackUrl()" class="color-2aabe1"><i class="fas fa-arrow-left"></i> BACK</a>
          <a v-else href="javascript:void(0);" @click="showBizList" class="color-2aabe1"><i class="fas fa-arrow-left"></i> BACK TO BUSINESS USERS</a>
        </p>
      </div>
    </div>
    <div class="columns is-multiline" v-if="!fetching_data">
      <div class="column is-full-mobile padding-bottom-0 is-paddingless">
        <div class="title is-marginless is-paddingless">
          {{ bizUserDetails.first_name + ' ' + bizUserDetails.last_name }}
          <span v-if="!fetching_data" class="is-size-7 is-italic has-text-weight-normal">Business User &nbsp;</span>
          <a class="underline edit-user" href="javascript:void(0);" @click="handleEditUSer" v-if="!form.edit_mode">Edit User</a>
          <a class="underline edit-user" href="javascript:void(0);" @click="cancelEditing" v-else>Cancel</a>
        </div>
      </div>
    </div>
    <div class="columns is-paddingless is-marginless">
      <div class="column padding-left-0 padding-top-0" >
        <div>
          <div class="card-content">
            <div class="content " v-if="!fetching_data">
              <div class="columns is-paddingless">
                <div class="column is-paddingless is-size-7 has-text-grey is-1 is-flex flex-align-centre">First name</div>
                <div class="column has-text-weight-bold is-paddingless is-marginless is-size-7 has-text-grey is-2 is-flex flex-align-centre" :class="{'is-italic': !bizUserDetails.first_name }">
                  <span v-if="!form.edit_mode">{{bizUserDetails.first_name || 'not provided'}}</span>
                  <input type="text" class="fit-content" v-model="form.first_name" v-else>
                </div>
                <div class="column is-paddingless is-size-7 is-size-7 has-text-grey is-1 is-flex flex-align-centre">Email</div>
                <div class="column has-text-weight-bold is-paddingless is-marginless is-size-7 has-text-grey is-3 is-flex flex-align-centre" :class="{'is-italic': !bizUserDetails.email }">
                  <span v-if="!form.edit_mode">{{bizUserDetails.email || 'not provided' }}</span>
                  <input type="text" class="fit-width" v-model="form.email" v-else>
                </div>
                <div class="column is-paddingless is-size-7 is-size-7 has-text-grey is-1">Last login</div>
                <div class="column has-text-weight-bold is-paddingless is-marginless is-size-7 has-text-grey is-2" :class="{'is-italic': !bizUserDetails.last_logged_in }">{{bizUserDetails.last_logged_in | getLastLoggedIn }}</div>
                <div class="column has-text-weight-bold is-paddingless is-marginless is-size-7 has-text-grey is-2 has-text-centered"><button class="button is-button-dark-blue is-uppercase" data-track="Portal - Admin | Saving User Details" v-if="form.edit_mode" :disabled="!formCompleted" @click="saveChanges">Save Changes</button></div>
              </div>
              <div class="columns is-paddingless">
                <div class="column is-paddingless is-size-7 is-size-7 has-text-grey is-1 is-flex flex-align-centre">Last name</div>
                <div class="column has-text-weight-bold is-paddingless is-marginless is-size-7 has-text-grey is-2 is-flex flex-align-centre" :class="{'is-italic': !bizUserDetails.last_name }">
                  <span v-if="!form.edit_mode">{{bizUserDetails.last_name || 'not provided' }}</span>
                  <input type="text" class="fit-content" v-model="form.last_name" v-else>
                </div>
                <div class="column is-paddingless is-size-7 is-size-7 has-text-grey is-1 is-flex flex-align-centre">Mobile</div>
                <div class="column has-text-weight-bold is-paddingless is-marginless is-size-7 has-text-grey is-3 is-flex flex-align-centre" :class="{'is-italic': !bizUserDetails.mobile_number }">
                  <span v-if="!form.edit_mode">{{bizUserDetails.mobile_number || 'not provided'}}</span>
                  <input type="text" class="fit-width" v-model="form.mobile_number" v-else>
                </div>
                <div class="column is-paddingless is-size-7 is-size-7 has-text-grey is-1 is-flex flex-align-centre"><p>&nbsp;</p></div>
                <div class="column has-text-weight-bold is-paddingless is-marginless is-size-7 has-text-grey is-2 is-flex flex-align-centre" :class="{'is-italic': !bizUserDetails.role }">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-paddingless is-marginless">
      <div class="column">
        <div>
          <div class="card-content biz-detail-content">
            <div class="" v-if="!fetching_data">
              <table class="table is-fullwidth">
                <thead>
                <tr>
                  <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey is-narrow-mobile is-desktop">Business</td>
                  <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey is-narrow-mobile is-desktop">Role</td>
                  <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey is-narrow-mobile is-desktop">Status</td>
                  <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey is-desktop is-hidden-mobile">Join date</td>
                  <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey is-desktop is-hidden-mobile">Notifications</td>
                  <td class="is-size-7 has-text-weight-bold is-narrow has-text-grey is-desktop"></td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in items" :key="index">
                  <td class="is-size-7 is-narrow-mobile is-desktop">{{ item.business_name }}</td>
                  <td class="is-narrow-mobile is-desktop is-size-7" v-if="item.role_name === 'Business User'">User &nbsp;&nbsp;
                    <a class="color-2aabe1 has-text-underlined"
                       href="#"
                       @click.prevent="makeAdmin(item)">MAKE ADMIN</a>
                  </td>
                  <td class="is-size-7 is-narrow-mobile is-desktop" v-else>Admin</td>
                  <td class="is-size-7 is-narrow is-narrow-mobile is-hidden-mobile">{{ item.status | getBizStatus }}</td>
                  <td class="is-size-7">{{ item.activated_at | prettyDate }}</td>
                  <td class="is-size-7 is-narrow notify-status is-hidden-mobile">
                    <label class=" has-text-centered">
                      <input type="checkbox" :checked="getEmailNotificationStatus(item.email_notifications)">
                      Email
                    </label>
                    <label class="has-text-centered sms-margin">
                      <input type="checkbox" :checked="getSMSNotificationStatus(item.receive_sms)">
                      SMS
                    </label>
                  </td>
                  <td class="is-size-7 is-narrow is-narrow-mobile is-desktop">
                    <a class="underline" v-if="item.status === 'ACCEPTED'" href="javascript:void(0);" @click="removeBizDetails(index,item.id,item.business_name)">REMOVE</a>
                  </td>
                </tr>
                </tbody>
              </table>
              <table v-if="!fetching_linked_biz && items.length === 0"
                     class="table is-fullwidth has-vertically-aligned-content">
                <tbody>
                <tr>
                  <td class="is-narrow">
                    <p class="is-size-7 has-text-weight-bold has-text-grey has-text-centered">No Linked businesses found for this business user.</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape, valid-jsdoc */
  import axios from 'axios'
  import Paginator from './../../components/Paginator.vue'
  import Rating from './../../components/Rating.vue'
  import misc from '../../mixins/misc.js'
  import moment from 'moment'
  import qs from 'qs'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Biz User Details'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Users'
      })
    },
    components: {Paginator, Rating},
    mixins: [misc],
    data () {
      return {
        fetching_data: false,
        fetching_linked_biz: false,
        bizUserDetails: null,
        no_of_items: 0,
        items: [],
        dataSet: {},
        page: undefined,
        total_records: 0,
        modal_props: {},
        bizName: '',
        formCopy: {},
        form: {
          role: null,
          email: null,
          edit_mode: false,
          first_name: null,
          last_name: null,
          mobile_number: null
        }
      }
    },
    created () {
      this.getBizUserDetails()
      this.getLinkedBusinesses(null)
      window.events.$on('deleteInvite', this.deleteOps)
    },
    destroyed () {
      window.events.$off('deleteInvite', this.deleteOps)
    },
    computed: {
      bizUserId () {
        return this.$router.currentRoute.params.bizUserId
      },
      formCompleted () {
        return this.form.first_name && this.form.last_name
      }
    },
    methods: {
      /* delete selected user from biz */
      deleteOps (props) {
          axios.get(`/auth/${props.producer.user}/delete-biz-user`)
              .then((response) => {
                  this.getBizUserDetails()
                  this.getLinkedBusinesses(null)
                  flash(`User deleted from ${this.bizName}`)
                  this.org_users.splice(props.producer.index, 1)
              })
              .catch((msg) => {
                  flash(msg.response.data.error, 'is-danger')
              })
      },
      /* show confirmation modal for deleting selected user */
      removeBizDetails (item, user, bizName) {
          // initialize event producer's props
          let producer = {}
          producer.index = item
          producer.user = user
          this.bizName = bizName

          this.modal_props = {
              title: 'Delete User?',
              body: 'You\'re about to delete this user from your account. If you proceed, all access for this user will be revoked.',
              btn_action_title: 'DELETE USER',
              show_btns: true,
              task: 'deleteInvite',
              producer: producer
          }
          // fire off confirmation modal
          this.deleteOps(this.modal_props)
      },
      /**
       * Makes an api call to make business user a business admin
       * @param {object} activeUser invite record
       * @returns {void}
       */
      makeAdmin (activeUser) {
          axios.get(`/make-admin/${activeUser.id}`)
              .then((response) => {
                  activeUser.role_name = 'Business Admin'
                  flash(response.data)
              })
              .catch((error) => {
                  flash(error.error, 'is-danger')
              })
      },
      /*  return email notification status */
      getEmailNotificationStatus (emailNotificationsStatus) {
         if (emailNotificationsStatus === 'ALL_REVIEW_ACTIVITY' || emailNotificationsStatus === 'NEW_REVIEW_ONLY') {
               return true
         } else {
              return false
         }
      },
      /* return sms notification status */
      getSMSNotificationStatus (smsNotificationsStatus) {
          if (smsNotificationsStatus) {
              return true
          } else {
              return false
          }
      },
      showBizList () {
          let query = qs.stringify(this.$route.query)
          let page = this.$route.query.page ? this.$route.query.page : 1
          this.$router.push(`/users-list/business-users?${query}&page=${page}`)
      },
      preventClick (event) {
        event.stopPropagation()
      },
      /**
       * Goes to reported reviews page for choosen busines
       * @param {object} item Review slug
       * @returns {void}
       */
      gotoReviewerDetails (item) {
        this.$router.push(`/users-list/reviewers/${item.id}`)
      },
      /**
       * Make request to api to get reported reviews listings
       * @returns {number | null}
       */
      getBizUserDetails () {
        this.fetching_data = true
        axios.get(`/users/biz-user/${this.bizUserId}`)
          .then((response) => {
            this.bizUserDetails = this.formCopy = response.data
            this.fetching_data = false
            Object.assign(this.form, this.bizUserDetails)
          })
          .catch(() => {
            flash('You are not authorized to view this resource.', 'is-danger')
            this.fetching_data = false
          })
      },
      /**
       * Make request to api to get reported reviews listings
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getLinkedBusinesses (page) {
        this.page = page
        this.fetching_linked_biz = true
        axios.get(this.url(page))
          .then((response) => {
            this.items = response.data
            this.fetching_linked_biz = false
          })
          .catch(() => {
            flash('You are not authorized to view this resource.', 'is-danger')
            this.fetching_linked_biz = false
          })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @return {string}
       */
      url (page) {
        let query = location.search.match(/page=(\d+)/)
        if (!page) {
          page = query ? query[1] : 1
        }
        return `/users/biz-user/linked-biz/${this.bizUserId}?page=${page}`
      },
      /**
       * has a back url in query string
       * @returns {void}
       */
      hasBackUrl () {
          return (this.$route.query.back !== undefined)
      },
      /**
       * Returns back to back page Url
       * @returns {void}
       */
      gotoBackUrl () {
          let url = this.hasBackUrl() ? this.$route.query.back : ''
          this.$router.push(url)
      },
      /**
       * Handle the Edit mode for user
       * @returns {void}
       */
      handleEditUSer () {
        this.form.edit_mode = true
      },
      /**
       * Cancel editing for user
       * @returns {void}
       */
      cancelEditing () {
        this.form.edit_mode = false
        Object.assign(this.form, this.formCopy)
      },
      /**
       * Save changes for user
       * @returns {void}
       */
      saveChanges () {
        axios.put(`admin/biz-users/${this.bizUserDetails.id}`, {
          email: this.form.email,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          mobile_number: this.form.mobile_number
        })
        .then(({data}) => {
          this.form.edit_mode = false
          // If changes its own details change in localstorage as well
          if (this.bizUserDetails.id === parseInt(localStorage.getItem('user_id'))) {
            localStorage.setItem('first_name', data.first_name)
            localStorage.setItem('last_name', data.last_name)
            localStorage.setItem('mobile_number', data.mobile_number)
            localStorage.setItem('email', data.email)
            window.events.$emit('profileUpdated')
          }
          Object.assign(this.form, data)
          Object.assign(this.formCopy, data)
          this.getLinkedBusinesses(null)
          this.displaySuccessMsg('User details saved successfully.', 'Portal - Admin | User Details Successfully')
          window.location.reload()
        })
        .catch(({response}) => {
          Object.keys(response.data).forEach((key, index) => {
            flash(response.data[key][0], 'is-danger')
          })
        })
      }
    },
    filters: {
      prettyDate (date) {
        return moment(date).format('DD-MM-YYYY')
      },
      getBizStatus (status) {
          let currentStatus = 'Pending'
          switch (status) {
              case 'ACCEPTED':
                  currentStatus = 'Active'
                  break

              case 'DELETED':
                  currentStatus = 'Deleted'
                  break

              case 'NEW':
                  currentStatus = 'Pending'
                  break

              case 'REVOKED':
                  currentStatus = 'Revoked'
                  break

              case 'EXPIRED':
                  currentStatus = 'Expired'
                  break

              default:
                  currentStatus = 'Pending'
          }
          return currentStatus
      },
      /**
       * Get last logged in time
       * @param {string} date Last logged in date
       * @returns {string}
       */
      getLastLoggedIn (date) {
          return date ? moment(date).format('DD-MM-YYYY HH:mm') : 'user has not logged in'
      }
    }
  }
</script>

<style scoped>
  .table td, .table th {
    border: none;
  }

  .table > tbody > tr {
    background-color: #f5f5f5 !important;
    margin-bottom: 10px;
  }

  .table > tbody > td {
    margin-bottom: 20px;
  }
  .table > tbody > tr > td > a {
    color: #30aae1;
  }
  .tag.is-private {
    background-color: #c4cbd1;
    color: #58595b;
    font-size: 0.65rem;
  }

  .is-on-grey-strap {
      background: transparent !important;
      border: 0;
  }
  .column {
    padding-left: 0 !important;
  }
  table thead:hover {
    background: #fff !important;
  }
  .notify-status {
    pointer-events: none;

    /* for "disabled" effect */
    opacity: 0.5;
  }
  .card-content {
    padding-left: 0!important;
  }
  .sms-margin {
    margin-left: 15px;
  }
  .biz-detail-content {
    padding-top: 0!important;
  }
  .biz-detail-container {
    padding-left: 2% !important;
  }
  .table td.is-narrow {
    width: 18% !important;
  }
  .width-half {
    width: 50%;
    margin: 0 0 0 25%;
  }
  .button {
    height: 29.1px;
  }
  .button[disabled] {
    color: #cdcbcb !important;
    border: solid 1px #cdcbcb;
    background: #ffffff !important;
  }
  input[disabled] {
    background-color: #f5f5f5;
  }
  input {
    padding: 4px 8px;
    border: solid 1px rgba(88, 89, 91, 0.32);
    background-color: #ffffff;
  }
  .card-content .content .columns:first-child {
    margin: 0 0 5px 0;
  }
  select {
    color: #868686;
    border: solid 1px rgba(88, 89, 91, 0.32);
    padding: 0 8px;
    height: 24px;
    outline: none;
    background-color: #ffffff;
  }
  .underline {
    text-decoration: underline;
  }
  .edit-user {
    color: #30aae1;
    font-size: 12px;
  }

  /*Mobile view*/
  @media screen and (min-width: 1000px) and (max-width: 1400px) {
    .fit-content {
      width: 90%;
    }
    .fit-width {
      width: 70%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/users/BizUserDetails.vue